import React, { useEffect, useState } from "react";
import BigTestimonials from "./bigScreen";
import SmallTestimonials from "./smallScreen";

const Testimonials = () => {
  const [matches, setMatches] = useState(window.matchMedia("(min-width: 768px)").matches);

  useEffect(() => {
    const handler = e => setMatches(e.matches);
    const mediaQuery = window.matchMedia("(min-width: 768px)");
    mediaQuery.addEventListener('change', handler);
    return () => {
      mediaQuery.removeEventListener('change', handler);
    };
  }, []); 

  return (
    <>
      {matches ? (<BigTestimonials/>) : (<SmallTestimonials />)}
    </>
  );
};

export default Testimonials;


